import {jsPDF} from "jspdf";
import {popupCreateUpdateTool} from "../common/PopupForms";
import Helper from "../common/Helper";
import {data} from "autoprefixer";

function downloadQRCode(name, code) {

    const nameSerialized = name.replace(/[^a-z0-9]/gi, '_').toLowerCase();
    const qrUrl = `${ESR.siteurl}/tool/${code}/`;
    const fileName = `${code.toLowerCase()}.pdf`;

    const tempContainer = document.createElement('div');
    tempContainer.style.position = 'absolute';
    tempContainer.style.left = '-9999px';
    document.body.appendChild(tempContainer);

    try {

        new QRCode(tempContainer, {
            text: qrUrl,
            width: 1024,
            height: 1024,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QRCode.CorrectLevel.H
        });

        setTimeout(() => {

            const canvas = tempContainer.querySelector('canvas');

            if (!canvas) {
                ESR.Popup.error({text: 'Eroare la generarea codului QR'});
                document.body.removeChild(tempContainer);
                return;
            }

            const qrSize = canvas.width;
            const textHeight = 160;

            const finalCanvas = document.createElement('canvas');
            finalCanvas.width = qrSize;
            finalCanvas.height = qrSize + textHeight;

            const ctx = finalCanvas.getContext('2d');

            // background alb
            ctx.fillStyle = "#ffffff";
            ctx.fillRect(0, 0, finalCanvas.width, finalCanvas.height);

            // QR
            ctx.drawImage(canvas, 0, 0);

            // text
            ctx.fillStyle = "#000000";
            ctx.font = "bold 160px Arial";
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            ctx.fillText(code, qrSize / 2, qrSize + (textHeight / 2) + 34);

            const widthMM = 40;
            const heightMM = 40;
            const margin = 2; // mm (quiet zone)

            const pdf = new jsPDF({
                orientation: "portrait",
                unit: "mm",
                format: [widthMM, heightMM]
            });

            const imgData = finalCanvas.toDataURL('image/png');

            pdf.addImage(
                imgData,
                'PNG',
                margin,
                margin,
                widthMM - margin * 2,
                heightMM - margin * 2
            );

            pdf.save(fileName);

            document.body.removeChild(tempContainer);

        }, 150);

    } catch (error) {

        console.error(error);
        ESR.Popup.error({text: 'Eroare la generarea codului QR'});
        document.body.removeChild(tempContainer);

    }
}


export default function tableTools(HelperTable) {

    const selectorTable = '#table-tools';
    const elTable = $(selectorTable)

    if (!elTable?.length) {
        return;
    }

    const canCreate = Helper.userCan('create_tool')
    const canEdit = Helper.userCan('edit_tool')
    const canDelete = Helper.userCan('delete_tool')

    const canViewAssignment = Helper.userCan('view_tool_assignment')


    const columns = [
        {
            data: 'id',
            label: 'ID',
            orderable: true
        },
        {
            data: 'name',
            label: 'Denumire',
            orderable: true,
            render: (data, type, row) => {

                if (type === 'display') {
                    return `<a  href="${ESR.Helper.getToolUrl(row.code.toLowerCase())}">${row.name}</a>`;
                }

                return data;
            }
        },
        {
            data: 'id',
            label: 'Acțiuni',
            orderable: false,
            className: 'actions no-export',
            render: (data, type, row) => {

                if (type === 'display') {
                    const url = ESR.Helper.getToolUrl(row.code.toLowerCase())
                    if (row.user_id && canViewAssignment) {
                        return `<a class="btn-action" href="${url + 'history/'}">Istoria</a>`;
                    }
                }

                return '';
            }
        },
        {
            data: 'serial_number',
            label: 'Serie'
        },
        {
            data: 'code',
            label: 'Cod',
            className: 'font-mono'
        },
        {
            data: 'user_id',
            label: 'Deținător',
            visible: true,
            render: function (data, type, row) {

                if (Number(data) === 0) return 'N/A';

                if (type === 'display' || type === 'search') {
                    return ESR.Helper.getUserNameById(data);
                } else {
                    return data;
                }
            }
        },
        {
            data: 'id',
            defaultContent: '',
            label: 'QR Code',
            orderable: false,
            searchable: false,
            className: 'text-center no-export',
            render: function (data, type, row) {
                if (type === 'display') {
                    return `<button class="link link-primary btn-download-qr" data-code="${row.code}" data-name="${row.name}" >Descarcă QR</button>`;
                }
                return '';
            }
        },
        {
            data: 'is_active',
            label: 'Statut',
            orderable: false,
            render: function (data, type, row) {

                if (type === 'display') {
                    return data === '1' ? 'Activ' : 'Inactiv';
                }

                return data;
            }
        },
        {data: 'created_at', label: 'Creat La', visible: false},
        {data: 'updated_at', label: 'Actualizat La', visible: true},
    ];

    const columnDefs = [
        // {
        //     targets: 8, // Created At
        // width: '150px',
        // render: function (data, type, row) {
        //     if (type === 'display') {
        //         const date = new Date(data);
        //         return date.toLocaleString('ro-RO', {
        //             year: 'numeric',
        //             month: '2-digit',
        //             day: '2-digit',
        //             hour: '2-digit',
        //             minute: '2-digit'
        //         });
        //     }
        //     return data;
        // }
        // },
        // {
        // targets: 9, // Updated At
        // width: '150px',
        // render: function (data, type, row) {
        //     if (type === 'display') {
        //         const date = new Date(data);
        //         return date.toLocaleString('ro-RO', {
        //             year: 'numeric',
        //             month: '2-digit',
        //             day: '2-digit',
        //             hour: '2-digit',
        //             minute: '2-digit'
        //         });
        //     }
        //     return data;
        // }
        // }
    ];

    const myTableHeader = HelperTable.createRowHeader(columns);
    elTable.append(myTableHeader)

    let toolbarButtons = [HelperTable.btnColvis(), HelperTable.btnDownloads()];

    if (canCreate) {
        function callbackBtnAdd(e) {
            e.preventDefault();
            popupCreateUpdateTool({}, ESR.lang.update);
        }

        toolbarButtons.push(HelperTable.btnAdd(e => callbackBtnAdd(e)))
    }

    if (canEdit) {
        function callbackBtnEdit(e) {
            e.preventDefault();

            const elRow = table.row('.selected');

            if (!elRow.node()) {
                // "No row selected."
                return;
            }

            popupCreateUpdateTool(elRow.data(), ESR.lang.update);
        }

        toolbarButtons.push(HelperTable.btnEdit(e => callbackBtnEdit(e)))
    }

    if (canDelete) {
        function callbackBtnRemove(e) {
            e.preventDefault();

            const elRow = table.row('.selected');

            if (!elRow.node()) {
                // "No row selected."
                return;
            }

            const rowData = elRow.data();

            ESR.Popup.delete({
                title: rowData.title,
                html: `<p>Toată <b>datele</b> și <b>poze</b> vor fi șterse definitiv, doriți să ștergeți ?</p`,
                action: 'esr_remove_tool_assignment',
                id: rowData.id
            })
        }

        toolbarButtons.push(HelperTable.btnRemove(e => callbackBtnRemove(e)))
    }

    const table = new DataTable(selectorTable, {
        responsive: true,
        select: false,
        data: window.tableData,
        columns: columns,
        // columnDefs: columnDefs,
        stateSave: true,
        displayLength: 20,
        order: [
            [0, 'dsc']
        ],
        processing: false,
        serverSide: false,
        info: false,
        layout: {

            topStart: {
                buttons: toolbarButtons,
            },
            topEnd: {
                search: {
                    text: '',
                    placeholder: ESR.lang.search
                }
            },
            bottom: 'paging',
            bottomStart: null,
            bottomEnd: null
        },
        language: {
            emptyTable: ESR.lang.emptyTable,
        },
        initComplete: function () {


            const state = this.api().state.loaded()

            const colStatus = this.api().column(7);
            const colStatusStateValue = state?.columns[7].search.search ?? '';

            const elSelectStatus = ESR.View.select({
                value: colStatusStateValue,
                class: 'select-status select-sm',
                name: 'status',
                placeholder: ESR.lang.status,
                options: [
                    {value: 1, label: 'Activ'},
                    {value: 0, label: 'Inactiv'}
                ]
            }).on('change', function () {
                colStatus.search($(this).val(), {exact: true}).draw();
            });
            $('.dt-layout-end').prepend(elSelectStatus)


            /**
             * Select Users
             */

            const colUsersIndex = 5;
            const colUsers = this.api().column(colUsersIndex);
            const colUsersStateValue = state?.columns[colUsersIndex].search.search ?? '';

            let UsersOptions = [];
            this.api().column(colUsersIndex).data().unique().sort().each(function (d, j) {
                if (Number(d) === 0) return;
                UsersOptions.push({value: d, label: ESR.Helper.getUserNameById(d) ?? ''});
            });

            const elSelectUsers = ESR.View.select({
                value: colUsersStateValue,
                class: 'select-user select-sm',
                name: 'status',
                placeholder: 'Deținător',
                options: UsersOptions
            }).on('change', function () {
                colUsers.search($(this).val(), {exact: true}).draw();
            });

            $('.dt-layout-end').prepend(elSelectUsers)


        }
    });


    if (canCreate) {
        const btnRowEdit = table.buttons().container().find('.btn-row-edit')
        const btnRowRemove = table.buttons().container().find('.btn-row-remove')
        $('body').on('click', (e) => {
            // Don't select row if clicking the QR button
            if ($(e.target).closest('.btn-download-qr').length) {
                return;
            }
            HelperTable.onSelectRow(e, table, btnRowEdit, btnRowRemove)
        });

        // QR Code download button click handler
        table.on('click', '.btn-download-qr', function (e) {
            e.stopPropagation();

            const inventory_code = $(this).data('code');
            const name = $(this).data('name');

            if (inventory_code && name) {
                downloadQRCode(name, inventory_code);
            }
        });
    }

}